import { siteInfo } from '@/mocks/siteInfo';

const features = [
  {
    icon: 'ri-links-line',
    title: '多入口保障',
    description: '提供多个官方备用入口，确保无论何种网络环境下都能稳定访问17c.com。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全防护',
    description: '全站HTTPS加密传输，多层安全验证机制，守护您的访问安全和隐私数据。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速体验',
    description: '全球CDN加速节点覆盖，智能路由优化，为您提供毫秒级的页面加载速度。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7×24小时在线客服支持，快速响应您在使用过程中遇到的任何问题。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-50 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            数万用户信赖的访问平台
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            {siteInfo.name} 致力于为每一位用户提供安全、稳定、流畅的访问体验
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-1 mb-16">
          {[
            { value: siteInfo.stats.totalUsers, label: '累计用户' },
            { value: siteInfo.stats.dailyVisits, label: '日均访问' },
            { value: siteInfo.stats.yearsOnline, label: '年稳定运行' },
            { value: siteInfo.stats.satisfactionRate, label: '用户满意度' },
          ].map((stat) => (
            <div key={stat.label} className="text-center py-8">
              <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100/70 rounded-lg p-6 hover:bg-background-100 transition-colors group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}